import { render, staticRenderFns } from "./CentroCostoList.vue?vue&type=template&id=174a5923&scoped=true&"
import script from "./CentroCostoList.vue?vue&type=script&lang=js&"
export * from "./CentroCostoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174a5923",
  null
  
)

export default component.exports